import { useTranslate } from '@/hooks/useTranslate';

interface PayWithHeaderProps {
  label: string;
}

export const PayWithHeader = ({ label }: PayWithHeaderProps) => {
  const { t } = useTranslate();

  return (
    <div
      data-testid="pay-with-method-header"
      className="text-base text-card-foreground font-semibold"
    >{`${t('payWith')} ${label}`}</div>
  );
};
